import { render, staticRenderFns } from "./BenefitFiscalAvailability.vue?vue&type=template&id=d539e780"
import script from "./BenefitFiscalAvailability.vue?vue&type=script&lang=js"
export * from "./BenefitFiscalAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports